import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
// import CustomerList from './components/customer-list/customer-list';
import CustomerOrder from './containers/customer-orders';
import HomePage from './containers/home-page';
import Login from './containers/login';
import CustomerList from './containers/customer-list';
import OrderDetail from './containers/order-details';
import Notifications from './components/notifications/container';
// import TonnageReport from './components/tonnage-report/tonnage-report';
import MyPerformance from '../src/components/my-performance/container';
import Statement from './containers/statement';
import Settings from './containers/settings';
import App from './containers/app';
import { ProtectedRoute } from './components/common/protected_route';
import store from './store';
import Complaint from './containers/complaints-list';
import ComplaintDetail from './containers/complain-details';
import Loyalty from './containers/loyalty';

function AppRoutes() {
    return (
        <Router>
            <App>
              <Switch>
                <Route path="/login" component={Login} />
                <ProtectedRoute path="/home-page" component={HomePage} />
                <ProtectedRoute path="/customer-list" component={CustomerList} />
                <ProtectedRoute path="/customer-orders/:customerId" component={CustomerOrder} />
                <ProtectedRoute path="/order-detail/:customerId/:orderNumber" component={OrderDetail} />
                <ProtectedRoute path="/tonnage-report/:customerId" component={MyPerformance} />
                <ProtectedRoute path="/statement/:customerId" component={Statement} />
                <ProtectedRoute path="/loyalty/:customerId" component={Loyalty} />
                <ProtectedRoute path="/settings" component={Settings} />
                <ProtectedRoute path="/notifications" component={Notifications} />
                <ProtectedRoute path="/complaint-list/:customerId" component={Complaint} />
                <ProtectedRoute path="/complaint-detail/:customerId/:complaintId" component={ComplaintDetail} />
                <Route render={requireNotLoggedIn} />
              </Switch>
            </App>
        </Router>
    );
}

const requireNotLoggedIn = () => {
    const state = store.getState();
    const isLoggedIn = state.user && state.user._token;
    if (isLoggedIn) {
        return <Redirect to="/home-page" />
    }
    return <Redirect to="/login" />
    // return <Login {...props} />
}

export default AppRoutes;